import { Box, GridLayout, Typography } from '@wishket/design-system';

import { twJoin } from 'tailwind-merge';

import TutorialCard from './parts/TutorialCard';
import { AlarmIcon, HighLightIcon, ScrapIcon } from './parts/Icons';
import ProgressBar from './parts/ProgressBar';

interface TutorialProps {
  isScraped: boolean;
  isHighlighted: boolean;
  isSubscribedToAuthor: boolean;
}

const Tutorial = ({
  isScraped,
  isHighlighted,
  isSubscribedToAuthor,
}: TutorialProps) => {
  const progressItems = [isScraped, isHighlighted, isSubscribedToAuthor];
  const progressValue = progressItems.filter(Boolean).length;
  const progressTotal = progressItems.length;

  const isTutorialCompleted = progressValue === progressTotal;

  if (isTutorialCompleted) {
    return null;
  }

  const tutorialCards = [
    {
      title: '스크랩',
      description: '다시 읽고 싶은 콘텐츠',
      icon: <ScrapIcon />,
      href: process.env.NEXT_PUBLIC_APP_DETAIL_SCRAP_USAGE_URL || '',
      dimmed: isScraped,
    },
    {
      title: '형광펜',
      description: '기억하고 싶은 문장',
      icon: <HighLightIcon />,
      href: process.env.NEXT_PUBLIC_APP_DETAIL_SCRAP_USAGE_URL || '',
      dimmed: isHighlighted,
    },
    {
      title: '작가 알림',
      description: '관심 작가의 콘텐츠',
      icon: <AlarmIcon />,
      href: `${process.env.NEXT_PUBLIC_APP_YOZMIT_AUTHOR_URL}`,
      dimmed: isSubscribedToAuthor,
    },
  ].sort((a, b) => Number(a.dimmed) - Number(b.dimmed));

  return (
    <GridLayout>
      <Box
        className={twJoin(
          'bg-w-orange-10 grid-in-content',
          '-mx-5 px-5 desktop:bg-transparent desktop:pt-[60px]'
        )}
      >
        <Box
          className={twJoin(
            'w-full bg-w-orange-10 py-6',
            'desktop:overflow-hidden desktop:overflow-x-auto desktop:rounded-3xl desktop:p-8 desktop:scrollbar-hide'
          )}
          data-testid="landing-tutorial"
        >
          <Box className={twJoin('flex flex-col gap-6', 'desktop:flex-row')}>
            <Box
              className={twJoin('flex flex-col gap-3', 'desktop:min-w-[264px]')}
            >
              <Box className="flex flex-col gap-1">
                <Typography
                  variant="subTitle2"
                  className="font-bold text-w-gray-900"
                >
                  성장 잔디 만들기
                </Typography>
                <Typography variant="body1" className="text-w-gray-600">
                  미션을 완료하고 풍성한 잔디를 심어요.
                </Typography>
              </Box>
              <ProgressBar value={progressValue} total={progressTotal} />
            </Box>
            <Box
              className={twJoin(
                '-mx-5 flex gap-4 overflow-x-scroll px-5 scrollbar-hide',
                'desktop:mx-0 desktop:-mr-8 desktop:px-0 desktop:pr-8'
              )}
              data-testid="landing-tutorial-cards"
            >
              {tutorialCards.map((card) => (
                <TutorialCard key={card.title} {...card} />
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </GridLayout>
  );
};

export default Tutorial;
